import { ApiProperty } from '@nestjs/swagger'

export class CurrencyResponse {
	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: String })
	code: string
}
